/**
 * Disclaimer page — a single legal-text card under the shared page header.
 *
 * Typography for the dense legal paragraph (0.95rem / 1.8 line-height, gray,
 * justified) lives in `disclaimer.module.css`.
 */
import { Card, CardBody } from '@/components/Card';
import PageHeader from '@/components/PageHeader';
import styles from './disclaimer.module.css';

export default function DisclaimerPage(): JSX.Element {
  const currentYear = new Date().getFullYear();

  return (
    <div className="container">
      <PageHeader title="Disclaimer" />
      <Card className="mb-8">
        <CardBody className={styles.content}>
          <p>
            Any views and opinions expressed are for informational and/or similarly educational
            purposes only and are a reflection of the author&apos;s best judgment, based upon
            information available at the time obtained from sources believed to be reliable and
            providing information in good faith, but no responsibility is accepted for any errors
            or omissions. Charts and graphs provided herein are for illustrative purposes only.
            The information contained herein is only as current as of the date indicated, and may
            be superseded by subsequent market events or for other reasons. Some of the statements
            may be forward-looking statements or statements of future expectations based on the
            currently available information. Accordingly, such statements are subject to risks
            and uncertainties. For example, factors such as the development of macroeconomic
            conditions, future market conditions, unusual catastrophic loss events, changes in
            the capital markets and other circumstances may cause the actual events or results
            to be materially different from those anticipated by such statements. In no case
            whatsoever will Fulcrum be liable to anyone for any decision made or action taken in
            conjunction with the information and/or statements in this policy or for any related
            damages. Reproduction of this material in whole or in part is strictly prohibited
            without prior written permission of Fulcrum. Copyright © Fulcrum Asset Management
            LLP <span>{currentYear}</span>. All rights reserved.
          </p>
        </CardBody>
      </Card>
    </div>
  );
}
